module.exports = __webpack_public_path__ + "a2c4a261a239aa84463dc70e4bac9b9a.svg";